import React, { ReactNode } from 'react';
import './modal.scss';
import Button from './button';

interface ModalProps {
    children?: ReactNode;
    message: string;
    buttonText?: string;
    onCancel: () => void;
    onSubmit: () => void;
    showButton?: boolean;
    showCancelButton?: boolean;
    cancelButtonText?: string;
    isDisabled?: boolean;
    showIcon?: boolean;
}

const Modal: React.FC<ModalProps> = ({
    message,
    buttonText = "Close",
    onCancel,
    onSubmit,
    children,
    showButton = true,
    showCancelButton = false,
    cancelButtonText = 'Cancel',
    isDisabled = false,
}) => {

    const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget) {
            onCancel();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div className="modal-content">
                <div className="modal-body flex-column flex-gap-15">
                    <span>{message}</span>
                </div>
                {children}

                <div className="modal-footer flex-row flex-gap-20">
                    {
                        showCancelButton && (<Button theme="form-outline"  label={cancelButtonText} onClick={onCancel} />)
                    }
                    {showButton && (

                        <Button theme="form" disabled={isDisabled} label={buttonText} onClick={onSubmit} />
                    )}

                </div>

            </div>
        </div>
    );
};

export default Modal;
